export default "__VITE_ASSET__BTe6IU18__"